var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAirplaneMx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 24 24",
    width: "100%",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 19L21.5 19L21.5 21L2.5 21L2.5 19M21.7501 15.2708C21.7551 14.4438 21.0783 13.7646 20.2486 13.7693L14.752 13.7614L9.73961 5.75467L7.7627 5.75107L9.8983 13.7503L4.75342 13.7438L3.25103 11.7449L1.7495 11.7449L2.68626 15.2692L3.08439 16.7535L4.73856 16.7635L10.2377 16.7618L14.7397 16.7715L20.2337 16.7891C21.0783 16.7677 21.7451 16.0979 21.7501 15.2708Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3576 4.32844C10.2279 4.47828 10.0774 4.60965 9.91065 4.71809"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0339 1.18695C11.3929 0.786048 10.6988 0.900118 10.0662 1.20945L11.1525 1.88889C11.6462 2.1977 11.8152 2.83292 11.5064 3.32663C11.1976 3.82035 10.5359 3.97281 10.0422 3.664L8.95592 2.98456C8.95744 3.6857 9.15835 4.36439 9.79667 4.76366C10.1557 4.98821 10.5652 5.09232 10.9592 5.08538L11.529 4.99945C11.9965 4.85569 12.4454 4.53615 12.7252 4.08893C13.3428 3.1015 13.0213 1.80457 12.0339 1.18695Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6722 10.3152C19.3132 10.7161 20.0073 10.602 20.6398 10.2927L19.5536 9.61325C19.0599 9.30444 18.8908 8.66922 19.1996 8.1755C19.5085 7.68179 20.1702 7.52933 20.6639 7.83814L21.7501 8.51758C21.7486 7.81644 21.5477 7.13774 20.9094 6.73848C20.5504 6.51393 20.1408 6.40982 19.7468 6.41676L19.177 6.50269C18.7095 6.64645 18.2606 6.96598 17.9809 7.4132C17.3633 8.40064 17.6848 9.69756 18.6722 10.3152Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0552 3.09082L18.7582 6.658L17.6587 8.41587L11.9557 4.84869L13.0552 3.09082Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplaneMx);
export default __webpack_public_path__ + "static/media/airplane-mx.18dda3d1.svg";
export { ForwardRef as ReactComponent };